import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  },
  {
    path: '/reg_admin',
    name: 'reg_admin',
    component: () => import(/* webpackChunkName: "about" */ '../views/RegAdmin.vue')
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/Main.vue'),
    children: [
      // {id: 3, name: '회원정보 관리', icon: 'mdi-help-box', slider:false},
      // {id: 4, name: '단지정보 관리', icon: 'apartment', slider:false},
      // {id: 5, name: '점검 시설물 관리', icon: 'apartment', slider:false},
      // {id: 6, name: '점검자 관리', icon: 'apartment', slider:false},
      // {id: 7, name: '전달사항 관리', icon: 'apartment', slider:false},
      // {id: 8, name: '계약(외주) 업체 관리', icon: 'apartment', slider:false},
      // {id: 9, name: '점검 내역 (점검자 별)', icon: 'apartment', slider:false},
      // {id: 10, name: '점검 내역 (시설물 별)', icon: 'apartment', slider:false},

      {
        path: '/placeInfo',
        name: '시설(단지)정보 관리',
        meta: {
          desc: '관리중인 시설(건물) 목록입니다.<br>시설물 내 1개 동 단위로 구분 가능합니다 <strong style="color: red">최소 하나의 동이 필요합니다</strong> '
        },
        component: () => import('../views/PlaceInfo.vue'),
      },
      {
        path: '/facilityInfo',
        name: '점검 대상 시설물 관리',
        meta: {
          desc: '시설물 목록입니다.<br>시설물 점검 대상을 등록하세요. (어린이 놀이터, 전기실 등 주요 시설)'
        },
        component: () => import('../views/Facility.vue'),
      },
      {
        path: '/patroler',
        name: '점검자 관리',
        meta: {
          desc: '관리중인 점검자 목록입니다.'
        },
        component: () => import('../views/Patroler.vue'),
      },
      {
        path: '/notice',
        name: '전달사항 관리',
        meta: {
          desc: '전달사항 목록입니다.<br><strong>시설(건물) 별로 구분할 수 있으며 전체 공지로 등록할수도 있습니다</strong>'
        },
        component: () => import('../views/Notice.vue'),
      },
      {
        path: '/company',
        name: '계약(외주) 업체 관리',
        meta: {
          desc: '외주 업체 목록입니다<br><strong>전화번호 입력 시 앱에서 연결할 수 있습니다'
        },
        component: () => import('../views/CompanyInfo.vue'),
      },
      {
        path: '/userInfo',
        name: '회원정보 관리',
        component: () => import('../views/EditAdmin.vue'),
      },
      {
        path: '/patrolerHistory',
        name: '점검 내역 (점검자 별)',
        meta: {
          desc: '점검자 별 점검 기록입니다.'
        },
        component: () => import('../views/PatrolerHistory.vue'),
      },
      {
        path: '/contractCompany',
        name: '계약업체 관리',
        meta: {
          desc: '계약업체(시설관리자)를 관리할 수 있습니다.'
        },
        component: () => import('../views/ContractCompany.vue'),
      },
      {
        path: '/advertisement',
        name: '광고 관리',
        meta: {
          desc: '앱에 노출되는 광고를 관리할 수 있습니다'
        },
        component: () => import('../views/Advertise.vue'),
      },


    ]
  }
]

const router = new VueRouter({
  routes,
  // mode: 'history'
})

export default router
